import BlurSection from './blur-section'
export default BlurSection
